import {
    Box,
    TextField,
    IconButton,
    CircularProgress,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import PauseIcon from '@mui/icons-material/Pause';
import MessageBubble from './MessageBubble';

export default function ChatWindow({
    activeChat,
    input,
    loading,
    onInputChange,
    onSend,
    chats, activeChatId, chatTypeEffect, TogglePauseButton, showPauseButton, ResetChatTypeEffect, QuickSearch
}) {

    const StopLoadingText = () => {
        ResetChatTypeEffect();
    }

    return (
        <Box flex={1} display="flex" flexDirection="column">
            {/* Messages */}
            <Box flex={1} overflow="auto" px={3} py={2}>
                {chats.map((msg, idx) => (
                    //console.log(msg)
                    <MessageBubble QuickSearch={QuickSearch} isLastMessage={idx === chats.length - 1} TogglePauseButton={TogglePauseButton} chatTypeEffect={chatTypeEffect} key={idx} message={msg} />
                ))}

                {loading && <CircularProgress size={18} />}
            </Box>

            {/* Input */}
            {
                activeChatId === '' ?
                    null :
                    <Box
                        p={2}
                        borderTop="1px solid #565869"
                        bgcolor="#343541"
                    >
                        <Box
                            display="flex"
                            bgcolor="#40414F"
                            borderRadius={2}
                            px={2}
                        >
                            <TextField
                                fullWidth
                                multiline
                                maxRows={4}
                                variant="standard"
                                placeholder="Message Pin Click GPT"
                                value={input}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onSend();
                                    }
                                }}
                                onChange={e => onInputChange(e.target.value)}
                                InputProps={{
                                    disableUnderline: true,
                                    style: { color: '#ECECF1' },
                                }}
                            />
                            {
                                showPauseButton ?
                                    <IconButton onClick={StopLoadingText}>
                                        <PauseIcon sx={{ color: '#ECECF1' }} />
                                    </IconButton>
                                    :
                                    <IconButton onClick={onSend}>
                                        <SendIcon sx={{ color: '#ECECF1' }} />
                                    </IconButton>
                            }

                        </Box>
                    </Box>
            }

        </Box>
    );
}
